// extracted by mini-css-extract-plugin
module.exports = {"star":"_1it0E","full-star":"_1Ty-6","half-star":"ZzU3C","stop-blank":"_8cm06","stop-fill":"_26lQG","blank-star":"_2U21l"};